// Libraries
import React from 'react';
import PropTypes from 'prop-types';

const getPageInfo = (totalPages, currentIndex, pageLength, pagePerView) => {
    // default to first page
    const IndexGap = 1;
    const halfNumber = 2;
    const currentPage = currentIndex || IndexGap;
    const pageSize = pageLength;

    let endPage, startPage;
    if (totalPages.length <= pagePerView) {
        // less than Page Per View total pages so show all
        startPage = IndexGap;
        endPage = totalPages.length;
    } else {
        // more than 10 total pages so calculate start and end pages
        const endPageCalc = currentPage + (pagePerView - IndexGap);
        const halfOfPagePerView = Math.ceil(pagePerView / halfNumber);
        if (currentPage <= halfOfPagePerView) {
            // For less than half number of page per view
            startPage = IndexGap;
            endPage = pagePerView;
        } else if (endPageCalc >= totalPages.length) {
            // For handling than last pages.
            const diff = endPageCalc - totalPages.length;
            startPage = currentPage - diff;
            endPage = totalPages.length;
        } else {
            startPage = currentPage - (halfOfPagePerView - IndexGap);
            endPage = currentPage + (halfOfPagePerView - IndexGap);
        }
    }

    // create an array of pages to ng-repeat in the pager control
    const pages = [...Array(endPage + IndexGap - startPage).keys()].map(
        index => startPage + index
    );

    // return object with all pager properties required by the view
    return {
        currentPage,
        endPage,
        pages,
        pageSize,
        startPage,
        totalPages,
    };
};

const PaginationNumber = ({
    pagesCount,
    pageIndex,  //0 NaN
    gotoPage,
    pageSize, //10
    pagePerView,  //3, 5
}) => {
    console.log("Pagination PaginationNumber---->",
        pageIndex, + "pageIndex->");
    const paginationGap = 1;
    const currentPage = pageIndex + paginationGap;
   
    const pageList = getPageInfo(
        pagesCount,  // 1 to 40
        currentPage, // 1
        pageSize,    // 10
        pagePerView  //3, 5
    );
    console.log("Pagination getPageInfo---->", pagesCount);
    return pageList.pages.map(countValue => {
        const pageCount = countValue - paginationGap;
        console.log("pagination pageCount", pageCount);
        return (
            <li key={pageCount}>
                <button
                    onClick={() => gotoPage(pageCount)}
                    className={`pageLink ${
                        pageCount === pageIndex ? 'selected' : null
                    }`}
                >
                    {countValue}
                </button>
            </li>
        );
    });
};

const Pagination = ({
    pageSize,
    pageSizeOptions,
    previousPage,
    canPreviousPage,
    pagesCount,
    gotoPage,
    nextPage,
    canNextPage,
    setPageSize,
    pageIndex,
    paginationLabel,
    totalItems,
    pagePerView,
    id,
}) => {
    // console.log("inside Pagination", pageSize,
    //     pageSizeOptions, //10
    //     previousPage, // [10,20,40,60]
    //     canPreviousPage,
    //     pagesCount, // 1 to 40
    //     gotoPage,
    //     nextPage,
    //     canNextPage,  //true 
    //     setPageSize,
    //     pageIndex,  // 0
    //     paginationLabel, //Rows per page
    //     totalItems,
    //     pagePerView,  //3
    //     id)
    return(
    <div className="paginationSec" id={`pagination-${id}`}>
        <ul className="pagination">
            <li>
                <label>{paginationLabel}</label>
                <select
                    value={pageSize}
                    className="numberOfRows"
                    onChange={event => {
                        setPageSize(Number(event.target.value));
                    }}
                >
                    {pageSizeOptions.map(pageSize => (
                        <option key={pageSize} value={pageSize}>
                            {pageSize}
                        </option>
                    ))}
                </select>
            </li>
            <li>
                <button
                    onClick={() => previousPage()}
                    disabled={!canPreviousPage}
                    className={`pageLink ${!canPreviousPage ? 'disabled' : ''}`}
                >
                    Previous
                </button>
            </li>
            <PaginationNumber
                gotoPage={gotoPage}
                pagesCount={pagesCount}
                pageIndex={pageIndex}
                pageSize={pageSize}
                totalItems={totalItems}
                pagePerView={pagePerView}
            />
            
            <li>
                <button
                    onClick={() => nextPage()}
                    disabled={!canNextPage}
                    className={`pageLink ${!canNextPage ? 'disabled' : ''}`}
                >
                    Next
                </button>
            </li>
        </ul>
    </div>
   )
};
Pagination.propTypes = {
    canNextPage: PropTypes.bool,
    canPreviousPage: PropTypes.bool,
    gotoPage: PropTypes.func,
    nextPage: PropTypes.func,
    pageIndex: PropTypes.number,
    pagePerView: PropTypes.number,
    pagesCount: PropTypes.array,
    pageSize: PropTypes.number,
    pageSizeOptions: PropTypes.array,
    paginationLabel: PropTypes.string,
    previousPage: PropTypes.func,
    setPageSize: PropTypes.func,
    totalItems: PropTypes.number,
    id: PropTypes.string,
};

export default Pagination;
